

























import { Vue, Component } from "vue-property-decorator";
import { deviceCountModule } from "@/store/modules/devicesList";

@Component
export default class DeviceCount extends Vue {
  public headers = [
    {
      text: "機器名",
      align: "start",
      value: "device"
    },
    { text: "個案數量", value: "count" },
  ];

  get loading() {
    return deviceCountModule.loading;
  }

  get deviceList() {
    return deviceCountModule.deviceList;
  }
  created() {
    deviceCountModule.deviceCountList();
  }
}
